import { AnimationHelper } from "./animation_helper";
import { waitFor } from "./async";
import { KryptonConstants } from "./krypton_constants";

function kryptonApp(): any {
    return document.getElementById("krypton-app");
}

export function getContentHtml(content: string): HTMLElement {
    // Keeping the commmented code below, for debugging we can switch to innertHTML and see the behavior.
    // const fragment = document.createElement("div");
    // fragment.innerHTML = content;
    // return fragment as HTMLElement;
    // Many templates have additional closing tags which causes DOMParser to incorrectly remove a few last elements, adding a few div tags at the beginning
    // seems to fix those.  This could be removed once all templates are fixed
    let dom = new DOMParser().parseFromString("<div><div><div><div>" + content + "</div></div></div></div>", 'text/html').body;
    // If noscript tag is present, it gets redirected to browser_compliance.html.  This is right now removed from default_header.xml so we don't have to
    // do anything here!
    // dom.querySelectorAll("noscript").forEach(el => el.remove());
    return dom.firstElementChild as HTMLElement; // firstElement child will be div, thereby excluding unnecessary body tag
}

export function getNameSpace(...nameSpace: string[]): any {
    var tmp = window;
    nameSpace.forEach((el) => {
        tmp = tmp[el];
    });
    return tmp;
}

async function fetchPage(url: string) {//Fetch page and apply script and styles
    let newPage: any = await kryptonApp().fetchDebugPage(url);
    newPage.applyScriptsAndStyles();
    newPage.open = true;
    return newPage;
}

export function createNotification(message: String, type: String,) {
    kryptonApp().createNotification(message, type);
}

export function showLoadingCurtain(detail?: any) {
    if (detail && detail.loadingCurtainDetails && detail.loadingCurtainDetails.manualCloseDelay) {
        kryptonApp().loadingCurtain.allowManualCloseAfter = detail.loadingCurtainDetails.manualCloseDelay
    } else {
        kryptonApp().loadingCurtain.reset();
    }
    kryptonApp().loadingCurtain.open = detail?.loadingCurtainDetails?.msg || true;
}

export function hideLoadingCurtain() {
    // Let the framework handle when to hide curtain. Ideally individual pages should not invoke this method unless it is absolutely necessary (like displaying a dialog)
    kryptonApp() && (kryptonApp().loadingCurtain.open = false);
}

export function loadJavaScript(url: any, callback: any) {
    window["jQuery"].ajax({
        url: url,
        dataType: 'script',
        success: callback,
        async: false
    });
}

export function openModule(url: string) {
    showLoadingCurtain();
    if (!/^\/?WebDispatch\//.test(url) && !/^\/?error\//.test(url)) {
        var tmp = "/WebDispatch/" + url;
        url = tmp.replace(/\/+/g, "/");
    }
    kryptonApp().pageManager.clear();//remove all pages and then load the new page as a fresh one
    resetPageScroll();
    (async () => {
        let page = await kryptonApp().fetchDebugPage(url);
        await kryptonApp().showPage(page);
    })()
}

export function resetPageScroll() {
    // We need to stop smooth scrolling now as pages like SMF screens may have horizontal sliding and it may conflict with this vertical scrolling
    let html: any = document.querySelector("html");
    if (html) {
        html.classList?.add("stop-smooth-scroll");
        setTimeout(() => {
            window.scrollTo(0, 0);
            document.querySelector("html")?.classList?.remove("stop-smooth-scroll");
        }, 100);
    }
}

export function openOverlay(url: string, detail: any = undefined) {
    showLoadingCurtain();
    (async () => {
        let topPage: any = kryptonApp().pageManager.topPage;
        let oldForm = (topPage && topPage.querySelector) ? topPage.querySelector("form") : null;// For filter first, when openOverlay is called, there may not be a top page
        let newPage = await kryptonApp().fetchDebugPage(url);
        let frm = newPage.querySelector("form");
        if (frm && oldForm) {
            frm.openerForm = oldForm;
        }
        let animator = AnimationHelper.ANIMATE_VERTICAL;
        if (detail?.animate && topPage) {
            await animator.animateSlideOut(topPage);
        }
        await kryptonApp().showPage(newPage, false, true);
        if (detail?.animate) {
            await animator.animateSlideIn(newPage);
        }
    })();
}

export async function openSlider(url: string, details: any) {
    showLoadingCurtain();
    let slider: any = kryptonApp().pageManager?.topPage?.querySelector("slider-canvas");
    if (!slider) {
        // When filter first is chosen, this method could get invoked, we  just need to open it in an overlay!
        openOverlay(url, { animate: kryptonApp().pageManager?.topPage != kryptonApp().pageManager?.bottomPage });
        return;
    }
    let sliderElement: any | null = slider.querySelector("#" + details.sliderName);
    let newPage = await fetchPage(url);
    let frm = newPage.querySelector("form")
    if (frm) {
        frm.openerForm = kryptonApp().pageManager?.topPage?.closest("form");
    }
    if (!sliderElement) {// If this is the first time, create a slider
        sliderElement = slider.createNewSliderElement(details, newPage);
        slider.appendChild(sliderElement)
    } else {// Slider already exists, so just append the newPage
        let div: any = sliderElement.querySelector("#" + details.sliderName + "-div");
        div.textContent = "";
        div.appendChild(newPage);
    }
    slider.doNavigateToSlide("#" + details.sliderName);
    hideLoadingCurtain();
}

function slideTo(event: Event, targetSelector: any) {
    event.preventDefault();
    let element: any = event.target;
    while (element) {
        if (element.localName === "slider-canvas") {
            element.doNavigateToSlide("#" + targetSelector);
            return;
        }
        element = element.parentElement;
    }
}

function slideBack(event: Event, det: any) {
    event.preventDefault();
    let element: any = event.target;
    let sliderCanvas: any = element.closest("slider-canvas")
    if (sliderCanvas) {
        let sliderElement: any = element.closest("slider-element")
        let sliderElementDiv: any = sliderElement.querySelector("#" + sliderElement.id + "-div");
        sliderCanvas.doNavigateSlideBack("#" + sliderCanvas.firstElementChild.id);
        if (sliderElement.hasAttribute("created") && sliderElementDiv) {
            // We need to clear the content when we move back as this is no longer used, and also this will avoid naming conflicts
            // For example document.forms['search'] can be used in different pages and may get conflicted
            sliderElementDiv.textContent = "";
        }
        return;
    } else {
        let element: any = event.target;
        // Make sure we don't close different pages
        if (element.closest("page-element") === kryptonApp().pageManager.topPage) {
            closeOverlay();
        }
    }
}

export function closeOverlay(page: any = kryptonApp().pageManager.topPage, donotCloseLoadingCurtain?: boolean) {
    if (page === kryptonApp().pageManager.bottomPage) {
        return;
    }
    showLoadingCurtain();
    if (!(page && page.localName === "page-element")) {
        page = kryptonApp().pageManager.topPage;
    }
    let opener = page.opener;
    if (opener === kryptonApp().pageManager.bottomPage && !donotCloseLoadingCurtain) {
        // We are getting back to the ledger page, so let's do it fast
        // The ledger could be a big page, so it is better to show it first and remove the overlay later.  Otherwise a blank screen appears for a while
        (async () => {
            opener.animateShow(true);
            await AnimationHelper.ANIMATE_VERTICAL.animateSlideOut(page, true, true, true);
            page.remove();
            kryptonApp().showOrHideFooter(true);
            hideLoadingCurtain();
        })();
        return false;
    }
    (async () => {
        await AnimationHelper.ANIMATE_VERTICAL.animateSlideOut(page, true, true, donotCloseLoadingCurtain);
        page.remove();
        if (!donotCloseLoadingCurtain) {
            if (!opener) {
                // Not a probable scenario.  Just in case, let's show the page below the closed page which should be topPage as the current page is closed.
                // But first, give it some time to adjust the stack!
                await waitFor(KryptonConstants.layerOpenAnimationTime)
                opener = kryptonApp().pageManager.topPage;
            }
            if (opener) {
                opener.open = true;
            }
            hideLoadingCurtain();
        }
        let slide = opener;
        // If we are going to the bottom page, we will not reach here, so this page should be animated if donotCloseLoadingCurtain is not set
        await AnimationHelper.ANIMATE_VERTICAL.animateSlideIn(slide, true, donotCloseLoadingCurtain, donotCloseLoadingCurtain);
    })();
    return false;
}

export function closeSlider(page: any = kryptonApp().pageManager.topPage) {
    if (page === kryptonApp().pageManager.bottomPage) {
        return;
    }
    showLoadingCurtain();
    if (!(page && page.localName === "page-element")) {
        page = kryptonApp().pageManager.topPage;
    }
    while (page && page != kryptonApp().pageManager.bottomPage) {
        let opener = page.opener;
        page.remove();
        page = opener;
    }
    kryptonApp().pageManager.bottomPage.open = true;
    hideLoadingCurtain();
}

// This method is used to get the current loading page and ideally should only be used for settting onContextMenu, onRefreshDocument and onExecuteMenu.
function getPage() {
    return kryptonApp().loadingPage;
}

// This will be method that will be invoked on click of a context menu (set from MenuMaker.java).
function processOnExecuteMenu(action: string, event: Event) {
    let el: any = event.target;
    let onExecuteMenu = el.closest("page-element")?.onExecuteMenu || kryptonApp().pageManager.topPage.onExecuteMenu;
    if (onExecuteMenu) {
        onExecuteMenu(action);
    }
}

// This will be method that will be invoked on click of refresh menu in the module header (set from MenuMaker.java).
function processOnRefreshDocument(action: string, event: Event) {
    let el: any = event.target;
    let onRefreshDocument = el.closest("page-element")?.onRefreshDocument || kryptonApp().pageManager.topPage.onRefreshDocument;
    if (onRefreshDocument) {
        onRefreshDocument(action);
    }
}

function isFirstOverlay(form: any) {
    let page = form.closest("page-element");
    return page && kryptonApp().pageManager.bottomPage === page.opener;
}

export function getVersion() {
    return kryptonApp() && kryptonApp().version;
}

window["openModule"] = openModule;
window["openOverlay"] = openOverlay;
window["closeOverlay"] = closeOverlay;
window["getNameSpace"] = getNameSpace;
window["createNotification"] = createNotification;
window["openSlider"] = openSlider;
window["closeSlider"] = closeSlider;
window["loadJavaScript"] = loadJavaScript;
window["slideTo"] = slideTo;
window["slideBack"] = slideBack;
window["showLoadingCurtain"] = showLoadingCurtain;
window["hideLoadingCurtain"] = hideLoadingCurtain;
window["getPage"] = getPage;
window["processOnExecuteMenu"] = processOnExecuteMenu;
window["processOnRefreshDocument"] = processOnRefreshDocument;
window["PopWindowHelp"] = () => { kryptonApp()._onClickHelp() };
window["isFirstOverlay"] = isFirstOverlay;
